import { Box, Typography, Select, MenuItem, FormControl } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { withAccount } from '@/utils/withAccount';
import { useMemo } from 'react';

const DashboardToolbar = ({
  title = 'Dashboard',
  subDashboards = [],
  rightSlot = null,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { accountId } = useParams();
  const handleChange = (e) => {
    const value = e.target.value;
    const path = withAccount(accountId, value);
    if (value) navigate(path);
  };
  const selected = useMemo(() => {
    return subDashboards.find((s) => location.pathname.includes(s.path))?.path;
  }, [location.pathname, subDashboards]);
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      my={2}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="h6">{title}</Typography>

        {subDashboards && subDashboards.length > 0 && (
          <FormControl size="small" variant="standard">
            <Select
              value={selected || ''}
              onChange={handleChange}
              IconComponent={ArrowDropDownIcon}
              sx={{ minWidth: 160 }}
            >
              {subDashboards.map((s) => (
                <MenuItem key={s.path} value={s.path}>
                  {s.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Box>

      <Box>{rightSlot}</Box>
    </Box>
  );
};

export default DashboardToolbar;
